import ValoresRepository from '@/services/ValoresRepository'
import ConfiguracionRepository from '@/services/ConfiguracionRepository'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    listaInventario: [],
    listaMaquina: [],
  },
  getters: {
    getInventario: (state) => (idInventario) => {
      return state.listaInventario.find(inventario => inventario.idInventario === idInventario)
    },

    getMaquina: (state) => (idMaquina) => {
      return state.listaMaquina.find(maquina => maquina.idMaquina === idMaquina)
    },
  },
  mutations: {
    setListaInventario(state, listaInventario) {
      state.listaInventario = listaInventario.map(inventario => {
        inventario.anioFabricacionFormated = inventario.anioFabricacion || ''
        inventario.fechaAdquisicionFormated = Vue.filter('fhDate')(inventario.fechaAdquisicion) || ''
        inventario.costoTotalFormated = Vue.filter('fhNumber')(inventario.costoTotal) + ' / ' + inventario.maquina.nombreUnidadMedidaCosto
        return inventario
      })
    },

    setListaMaquina(state, listaMaquina) {
      state.listaMaquina = listaMaquina.map(maquina => {
        maquina.costoTotalFormated = Vue.filter('fhNumber')(maquina.costoTotal) + ' / ' + maquina.nombreUnidadMedidaCosto
        return maquina
      })
    },

    clearInventario(state) {
      state.listaInventario = []
    },
  },
  actions: {
    async fetchListaInventario({state, commit, rootState}) {
      if (state.listaInventario && state.listaInventario.length > 0) {
        return
      }

      let idAgricultor = rootState.agricultor.agricultor.idAgricultor

      let listaInventario = await ValoresRepository.listaInventario(idAgricultor)
      commit('setListaInventario', listaInventario)
    },

    async fetchListaMaquina({state, commit}) {
      if (state.listaMaquina && state.listaMaquina.length > 0) {
        return
      }

      let listaMaquina = await ConfiguracionRepository.listaMaquina()
      commit('setListaMaquina', listaMaquina)
    },

    clearInventario({commit}) {
      commit('clearInventario')
    },
  }
}
